import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const BrakingDistanceCalculatorGuidePage = () => <DataDrivenGuidePage slug="guide-braking-distance-calculator" />;

export default BrakingDistanceCalculatorGuidePage;
